module.exports = __webpack_public_path__ + "img/full5-min.c515d395.png";